import { render, staticRenderFns } from "./reading-pen-detail.vue?vue&type=template&id=1762d446&scoped=true&lang=pug&"
import script from "./reading-pen-detail.vue?vue&type=script&lang=js&"
export * from "./reading-pen-detail.vue?vue&type=script&lang=js&"
import style0 from "./reading-pen-detail.vue?vue&type=style&index=0&id=1762d446&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1762d446",
  null
  
)

export default component.exports